import { createFileRoute, Outlet } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import z from 'zod'
import { PERMISSION_SUB_MODULES } from '@/shared/const'
import { PageWrapper } from '@/shared/ui/page-wrapper'
import { PermissionGuard } from '@/shared/ui/permission-guard'
import { ParentsWidget } from '@/widgets/parents-widget'

const searchSchema = z.object({
  'pagination.page': z.number().default(1),
  'pagination.pageSize': z.number().default(10).optional(),
})

export const Route = createFileRoute('/_auth/users/parents')({
  staticData: {
    meta: {
      title: 'Родители',
      description: '',
    },
  },
  validateSearch: searchSchema,
  component: RouteComponent,
})

function RouteComponent() {
  const { t } = useTranslation()

  return (
    <PermissionGuard permission={PERMISSION_SUB_MODULES.PARENTS}>
      <PageWrapper title={t('Родители')}>
        <ParentsWidget />
        <Outlet />
      </PageWrapper>
    </PermissionGuard>
  )
}
